import CardInfoDialog from './card-info-dialog.vue';

export default CardInfoDialog;